module.exports = __webpack_public_path__ + "static/media/export.7abe4da5.svg";